module.exports = __webpack_public_path__ + "img/logo-w.0274431f.png";